import type { SignupApi } from './signup-api';

/** Builds the local fake for the raw `?scenario=` value. */
export type LocalFakeSignupApiFactory = (scenarioParam: string | null) => SignupApi;

/**
 * The committed loader: there is no local fake. Production bundles always
 * resolve this file, so they never contain the fake or its canned data. A local
 * fakes dev server swaps it for `local-fakes/load-local-fakes.ts` by alias, and
 * so, for now, do dev and preview builds for the temporary gap fill
 * (`dev-gap-fill.ts`).
 */
export function loadLocalFakeSignupApi(): LocalFakeSignupApiFactory | null {
  return null;
}
